import { Directive, input } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * Base Editor Custom AgGrid for Numeric Input.
 * It contains common functionalities used by NumericCellEditorInlineComponent
 * and NumericCellEditorPopupComponent
 */
@Directive()
export abstract class NumericCellEditorBaseComponent {
    readonly numericFormControl = input.required<FormControl>();
    readonly separatorInUse = input.required<string>();
    readonly decimal = input.required<number | null>();
    readonly max = input.required<number | null>();
    readonly min = input.required<number | null>();
    readonly cellReady = input.required<boolean>();
    readonly PATTERNS = {
        MONEY: '^([+\\-])?(\\d+)?([.,])?(\\d{1,2})?$',
        NUMERIC_DECIMAL: '^([+\\-])?(\\d+)?([\\.,])?(\\d+)?$',
        NUMERIC_INTEGER: '^[+\\-]?\\d+$',
    };
}
